import { api } from "../../../../api/Middleware";
import { SAVED_VIEWS_URL, SAVED_VIEWS_REORDER_URL } from "../../../../api/Urls";

export const getSavedViews = async (pipelineId) => {
  const params = {};
  if (pipelineId) params.pipeline = pipelineId;
  const response = await api.get(SAVED_VIEWS_URL, { params });
  return response.data;
};

export const createSavedView = async (data) => {
  const response = await api.post(SAVED_VIEWS_URL, data);
  return response.data;
};

export const updateSavedView = async (id, data) => {
  const response = await api.patch(`${SAVED_VIEWS_URL}${id}/`, data);
  return response.data;
};

export const deleteSavedView = async (id) => {
  const response = await api.delete(`${SAVED_VIEWS_URL}${id}/`);
  return response.data;
};

export const reorderSavedViews = async (items) => {
  const response = await api.post(SAVED_VIEWS_REORDER_URL, items);
  return response.data;
};
